import Vue from "vue";

const templateId = +document.body.getAttribute("data-tplId") || +document.body.getAttribute("tplid");
const templatePath = "./templates/" + templateId + "/findbutton.js";

let component = Vue.component("findbutton", function(resolve, reject) {
  import(`${templatePath}`).then(res => {
    resolve({
      template: res.default,
      props: ['jsonval'],
      data() {
        return {
          xss: ''
        }
      },
      methods: {
        test() {
          window.location = window.location.pathname
        }
      }
    });
  });
});
export default component;
